export enum EFamilyTypes {
    Website = "WEBSITE",
    Apps = "APPS",
    Keyword = "KEYWORD",
    Categories = "CATEGORIES",
    Segments = "Segments",
    RankTracker = "RankTracker",
    Advertiser = "Advertiser",
    Publisher = "Publisher",
}
